import React from 'react';

const SEOContent: React.FC = () => {
  return (
    <section style={{ 
      padding: '3rem 0', 
      background: '#f8fafc',
      borderTop: '1px solid #e2e8f0'
    }}>
      <div className="container">
        {/* Visible content for users */}
        <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ 
            fontSize: '2rem', 
            fontWeight: 'bold', 
            color: '#1f2937', 
            marginBottom: '1rem' 
          }}>
            למה לבחור במעבדת שיניים טופ-טק?
          </h2>
          <div className="grid grid-cols-2" style={{ gap: '2rem', marginTop: '2rem' }}>
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#2563eb', marginBottom: '0.5rem' }}>
                מיקום נוח ברחובות
              </h3>
              <p style={{ color: '#6b7280' }}>
                ממוקמים בבית הפועלים 6, רחובות - נגישים לכל המרכז
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#2563eb', marginBottom: '0.5rem' }}>
                ניסיון של 40+ שנים
              </h3>
              <p style={{ color: '#6b7280' }}>
                מעבדת שיניים מובילה עם ניסיון רב בתחום
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#2563eb', marginBottom: '0.5rem' }}>
                טכנולוגיה מתקדמת
              </h3>
              <p style={{ color: '#6b7280' }}>
                ציוד חדיש ושיטות עבודה מתקדמות
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#2563eb', marginBottom: '0.5rem' }}>
                שירות אמין ומהיר
              </h3>
              <p style={{ color: '#6b7280' }}>
                זמני אספקה קצרים ושירות מקצועי
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SEOContent;